import Api from './Api';

const all = (payload) => {
    const path = '/sites-statement';
    const endpoint = payload ? `${path + '?' + Object.keys(payload).map(key => key + '=' + payload[key]).join('&')}` : path;

    return Api.getRequest({
        endpoint
    });
};

const downloadPDF = (payload) => {
    const path = '/download-sites-statement';
    const endpoint = payload ? `${path + '?' + Object.keys(payload).map(key => key + '=' + payload[key]).join('&')}` : path;

    return Api.getRequest({
        endpoint
    });
};

export default {
    all,
    downloadPDF
};
